import _ from 'lodash';

export default angular
  .module('doxy.global.models.room', [])
  .service('RoomMethods', function (User) {
    return {
      _adminUser: null,

      getDisplayName() {
        if (this.isPersonal) {
          return this.getAdminUser().getDisplayName() || this.name;
        } else {
          return (
            this.displayName ||
            this.getAdminUser().getDisplayName() ||
            this.name
          );
        }
      },

      getDisplayNameForLanding() {
        return (
          this.isPersonal
            ? this.getAdminUser().displayName || this.slug
            : this.displayName || this.slug
        ).replace(/\s+/g, ' ');
      },

      getAdminUser() {
        if (!(this._adminUser instanceof User)) {
          this._adminUser = new User(this.roomAdmin);
        }
        return this._adminUser;
      },
    };
  }).name;
